// Only form url for now, in the future add campaign name,
// google analytics, and all the other hidden fields we can get via window
export default windowLocation => {
  return {
    Form_URL__c: windowLocation.href,
  }
}
